module.exports = __webpack_public_path__ + "img/gamma_3_express.9ccbd45d.png";